import { isDesktop } from 'react-device-detect';
import FreespinStatusbarController from '../../controllers/freespin/FreeSpinStatusBarController';
import MainGridController from '../../controllers/grid/MainGridController';
import { COMPONENTS } from '../../lib/constants';
import { FreespinStatusbarGrid } from './FreespinStatusbarGrid';

export const FreespinStatusbarView = {
	name: COMPONENTS.FREESPIN_STATUS_BAR,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: FreespinStatusbarController,
			name: 'FreespinStatusBarController',
			config: {
				item: 'texts',
				val: 'texts',
				position: { x: 0, y: 120, w: 634 }
			}
		},
		{
			Controller: MainGridController,
			name: 'FreespinStatusbarGrid',
			config: FreespinStatusbarGrid
		}
	],
	components: [
		{
			name: 'bg',
			type: 'Sprite',
			position: { x: 0, y: 0 },
			components: [
				// {
				//   name: "bg",
				//   type: "Sprite",
				//   img: "bonus_reel_indicator",
				//   position: { x: 0, y: -35 },
				// },
				{
					name: 'border',
					type: 'Sprite',
					img: 'bonus_reel_border',
					position: { x: 0, y: -12 }
				},
				{
					name: 'texts',
					type: 'Sprite',
					components: [
						{
							name: 'FREE_SPIN_LEFT',
							type: 'Text',
							text: 'FREE_SPIN_LEFT',
							position: { x: 45, y: isDesktop ? 10 : 10 }
						},
						{
							name: 'FREE_SPIN_LEFT_AMOUNT',
							type: 'Text',
							text: 'FREE_SPIN_LEFT_AMOUNT',
							position: { x: 252, y: isDesktop ? 5 : 5 }
						},
						{
							name: 'FREE_SPIN_WIN',
							type: 'Text',
							text: 'FREE_SPIN_WIN',
							position: { x: 320, y: isDesktop ? 10 : 10 }
						},
						{
							name: 'FREE_SPIN_WIN_AMOUNT',
							type: 'Text',
							text: 'FREE_SPIN_WIN_AMOUNT',
							position: { x: 445, y: isDesktop ? 5 : 5 }
						}
					]
				}
			]
		}
	]
};
